import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitBtn"]
  static values = {
    redirectStatus: String
  }

  connect() {
    if (this.redirectStatusValue) {
      this.submitForm()
    }
  }

  submitForm() {
    this.showLoadingIndicator()

    if (this.element.dataset.remote) {
      Rails.fire(this.element, "submit")
    } else {
      this.element.submit()
    }
    this.submitBtnTarget.disabled = true
  }

  showLoadingIndicator() {
    document.getElementById("loading-indicator").style.display = "block"
  }
}
